import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootStore } from 'store/reducer';
import {
  ACCOUNTS_ACTIONS,
  selectAccountById,
  updateAccount
} from 'store/accounts';
import { displayAlert } from 'store/v1/ui/ui.actions';
import useModal from 'hooks/useModal';
import useEvent from 'v1/helpers/hooks/useEvent';

import { Button, EmailInput, Field, Form, RoleSelector } from 'shared';
import Modal from 'modals/layout';

type UserModalProps = {
  id: string;
};

type UserModalFormData = {
  email: Email;
  isAdmin: boolean;
};

const copy = {
  title: 'Edit user',
  cancel: 'Cancel',
  submit: 'Save changes'
};

const UserModal = ({ id }: UserModalProps) => {
  const dispatch = useDispatch();
  const { cancelModal, closeModal } = useModal();
  const account = useSelector((state: RootStore) =>
    selectAccountById(state, id)
  );

  useEvent([ACCOUNTS_ACTIONS.updateAccount], {
    onSuccess: () => {
      dispatch(displayAlert('success', 'Updated successfully'));
      closeModal();
    },
    onFailure: () => dispatch(displayAlert('error', 'An error occurred'))
  });

  const onSubmit = (data: UserModalFormData) => {
    dispatch(updateAccount({ id, data: { isSuperUser: data.isAdmin } }));
  };

  return (
    <Form<UserModalFormData> values={account} onSubmit={onSubmit}>
      <Modal size="s">
        <Modal.Header
          title={copy.title}
        />
        <Modal.Content>
          <Modal.Scrollable>
            <div className="stack-s">
              <Field label="Email" name="email" isRequired>
                <EmailInput isDisabled />
              </Field>
            </div>
            <Field label="Role" name="isAdmin">
              <RoleSelector />
            </Field>
          </Modal.Scrollable>
          <Modal.Toolbar>
            <Button label={copy.cancel} action={cancelModal} />
            <Button
              label={copy.submit}
              icon="tick"
              appearance="primary"
              hasMarginLeft
              action="submit"
            />
          </Modal.Toolbar>
        </Modal.Content>
      </Modal>
    </Form>
  );
};

export default UserModal;
